import { mapGetters } from 'vuex';

import buttonLoader from '@/components/button';

import Api from '@/utils/api';

import { DEFAULT_IMAGE } from '@/utils/const';

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    buttonLoader,
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,
      loadingButton: false,
      comment: '',
      load: false,

      infoMessage: 'Click ctrl + enter to save comment',
      errorLengthMax: 'Max characters 500',
      errorLengthMin: 'Min characters 1',
      message: this.infoMessage,
    };
  },
  computed: {
    ...mapGetters({
      userRole: 'userRole',
    }),
    checkCommentLength () {
      if (this.comment.length === 500) {
        this.message = this.errorLengthMax;
        return false;
      }
      if (this.comment.length < 1) {
        this.message = this.errorLengthMin;
        return false;
      }
      this.message = this.infoMessage;
      return true;
    },
  },
  methods: {
    sendComment () {
      if (!this.checkCommentLength) {
        return;
      }

      this.load = true;

      const params = {
        jobID: this.$route.params.id,
        innerText: this.comment,
      };

      Api.jobs.comments
        .addComment(params)
        .then((response) => {
          if (response.data.Status) {
            this.comment = '';
            this.$emit('sendComment');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
              listError: response.data.ErrorValues,
            });
          }

          this.load = false;
        });
    },
  },
};
